export const PAGE_FIX_FORM_FOOTER = {
    GO_TO: 'go-to',
    SUBMIT: 'submit',
} as const;
